<template>
  <div>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">
                {{ $t('extracurriculares.teachers_assistance.without_register') }}
              </v-btn>
          </template>
          <new-assistance
          :course="course"
          :schedule_id="schedule_id"
          v-on:closeModal="dialog = false"
          :current-assistance="assistance"
          :register_date="register_date"
          >
          </new-assistance>
      </v-dialog>
    </v-toolbar>
    <v-card>
      <v-card-title>
        {{ $t('extracurriculares.teachers_assistance.course_list') }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assistance"
        :search="search"
        :loading="loading"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.student.full_name }}</td>
          <td class="text-xs-center">{{ props.item.student.gender }}</td>
          <td class="text-xs-center">{{ props.item.student.grade_level }}</td>
          <td class="text-xs-center">{{ displayPowerAssistance(props.item.student.student_number) }}</td>
          <td class="text-xs-center">
            <v-checkbox
              :key="props.item.id"
              :name="`assist_${props.item.id}`"
              :input-value="props.item.assist == 1 ? true : false"
              @change="changeAssist(props.item.id)"
              color="primary"
              class="center"
            >
            </v-checkbox>
          </td>
          <td>
            <v-layout mt-2 row>
              <v-textarea
                rows="2"
                outline
                label="Notas"
                name="notes"
                v-model="notes[props.item.id]"
                hide-details
                @keypress.enter="saveNote(props.item.id)"
              >
              {{ props.item.notes }}
              </v-textarea>
            </v-layout>
            <v-layout row justify-end>
              <v-btn
              color="primary"
              small
              @click="saveNote(props.item.id)"
              >Save note</v-btn>
            </v-layout>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import NewAssistance from './new_assistance'
  export default {
    name: 'teacher-assistance-view',
    components: {
      'new-assistance': NewAssistance,
    },
    props: {
      course_id: {
        type: Number,
        required: true,
      },
      schedule_id: {
        type: Number,
        required: true
      },
      course: {
        type: Object,
        required: false
      },
      register_date: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        assistance: [],
        power_assistance: [],
        headers: [
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.stuent'), align: 'center', value: 'student.full_name' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.gender'), align: 'center', value: 'student.gender' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.gade'), align: 'center', value: 'student.grade_level' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.power_assist'), align: 'center', value: '' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.assist'), align: 'center', value: '' },
          { text: this.$t('extracurriculares.teachers_assistance.assistance.table.notes'), align: 'center', value: '' },
        ],
        search: '',
        loading: false,
        dialog: false,
        notes: {}
      }
    },
    watch: {
      schedule_id(newValue, oldValue) {
        if (newValue && newValue != 0) {
          this.loadAssistance()
        }
      },
      register_date(newValue, oldValue) {
        if (newValue && newValue != 0) {
          this.loadAssistance()
        }
      },
      dialog(newValue, oldValue) {
        if (!newValue && oldValue) {
          this.loadAssistance()
        }
      }
    },
    methods: {
      changeAssist(assist_id) {
        this.loading = true
        axios.post('/api/extracurriculares/teacher/assistance',
        {
          assist_id,
        })
        .then(() => {
          this.loading = false
        })
      },
      loadAssistance() {
        this.notes = {}
        this.loading = true
        const course_id =  this.$props.course_id
        const schedule_id =  this.$props.schedule_id
        const register_date =  this.$props.register_date
        axios.get(`/api/extracurriculares/teacher/assistance/${course_id}/${schedule_id}/${register_date}`)
          .then(resp => {
            if (resp.status === 200) {
              this.assistance = resp.data.assistance
              this.power_assistance = resp.data.power
              this.loading = false
              this.assistance.forEach(assist => {
                this.notes[assist.id] = assist.notes
              })
              console.log(JSON.stringify(this.power_assistance))
            }
          })
          .catch(error => console.log(error))
      },
      saveNote(assist_id) {
        const note = this.notes[assist_id]
        const id = assist_id
        if (note && note.trim() !== '') {
          axios.post('/api/extracurriculares/teacher/assistance/note', {
            note,
            id
          })
          .then(resp => {
            if (resp.status === 200) {

            }
          })
          .catch(error => console.log(error))
        }
      },
      displayPowerAssistance(student_number) {
        const assist = this.power_assistance.find((it) => it.student_number == student_number);

        if (assist !== undefined) {
          return assist.att_code
        }
      }
    },
  }
</script>

<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/teacher/assistance.vue